module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/tax-credit-bg-6a8b8e201bfe533edb15f53968b65218.svg";